class PostTemplate {
	getElement (post) {
		const div = document.createElement('div')
		div.innerHTML = this.getHtml(post)
		return div.firstElementChild
	}
	getHtml (post) {
		const publishedDate = new Date(post.published.replace(/ /g, 'T')).toLocaleDateString()

		const image = post.imageLink ? /* html */ `
			<picture>
				<img src="${post.imageLink}" alt="${post.title}" title="${post.title}" class="blog-img img-responsive">
			</picture>
		` : ''

		return /* html */ `
			<div class="col-12 col-md-6 col-lg-6">
				<div class="blog-item">
					<div class="blog-img-wrapper">
						<a class="" href="${post.link}" title="${post.title}">
							${image}
						</a>

					</div>
					<div class="blog-content">
					<div class="blog-date">
						${publishedDate}
					</div>

					<div class="blog-title">
						<h3>${post.title}</h3>
					</div>

					<p class="blog-readmore">${post.description}</p>
					<div class="buttons__wrapper">
						<a class="btn" href="${post.link}" title="Dowiedz się wiecej o robotach koszących, systemach nawadniania i oświetlenia">
							<span>Przejdź do wpisu</span>
						</a>
					</div>
					</div>
				</div>
			</div>
		`
	}
}

const postTemplate = new PostTemplate()
export {
	PostTemplate,
	postTemplate
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/mod_async_posts_loader/template/PostTemplate.js